import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconPlus } from '@redteclab/icons'

type AfterSalesImageControlAddImageButtonProps = {
  canAddMoreImages: boolean
  isMandatory?: boolean
  onClick: () => void
}

export const AfterSalesImageControlAddImageButton: FC<
  AfterSalesImageControlAddImageButtonProps
> = ({ canAddMoreImages, isMandatory, onClick }) => {
  return (
    <button
      className="flex flex-row items-center font-medium no-underline"
      data-qa-id="after-sales-image-control-open-image-upload"
      disabled={!canAddMoreImages}
      onClick={onClick}
      type="button"
    >
      <div
        className={clsx(
          'flex items-center text-m font-normal',
          canAddMoreImages
            ? 'text-dark-primary-max hover:text-dark-hover-brand'
            : 'text-dark-primary-strong',
        )}
      >
        <IconPlus className="size-8 fill-dark-brand" />
        <p className="text-m font-normal">
          <FormattedMessage id="damagedProducts.label.uploadImage" />
          {isMandatory ? '*' : null}
        </p>
      </div>
    </button>
  )
}
